import { api } from '../_services';
import Vue from "vue"

const defaultStatus = () =>  {
    return {
        daysLeft: '',
        days: '',
        noPlanStarted: false,
        trialAlert: false,
        trialAlertExpired: false,
        profileImage: 'https://abs.twimg.com/sticky/default_profile_images/default_profile_normal.png',
        loggedIn: false,
        userHash: '',
        email: false,
        id: 0,
        accounts: {
            instagram: []
        }
    }
}

const user = JSON.parse(localStorage.getItem('user'));
const data =  {
    info: defaultStatus(),
    user
}

const state = user ? data : { info: {
    loggedIn: false,
    profileImage: 'https://abs.twimg.com/sticky/default_profile_images/default_profile_normal.png'
    }, user: null };

const getters = {
    getEmail: state => {
        return state.info && state.info.email ? state.info.email : null
    }
}

const actions = {
    get({ commit }) {
        api.userInfo().then(
            res => {
                commit('onSuccess', { res })
            },
            error => commit('onError', error)
        )
    },
    startTrial({ commit }) {
        api.startTrial('TAG')
            .then(res =>{
                console.log(res)
                console.log('OK')
                api.userInfo().then(
                    res => {
                        commit('onSuccess', { res })
                    },
                    error => commit('onError', error)
                )
            }, error => {
                console.log(error)
            })
    }
};

const mutations = {
    onSuccess(
        state,
        {
            res: { data }
        }
    ) {
        if (data.plans.ritetag == null) {
            state.info.noPlanStarted = true
        } else {
            state.info.noPlanStarted = false
            state.info.daysLeft = data.plans.ritetag.expiration
            let dateNow = Date.parse(new Date())
            let expiration = Date.parse(data.plans.ritetag.expiration)
            if (dateNow > expiration) {
              state.info.trialAlertExpired = true
            }
            if (data.plans.ritetag.name === 'trial') {
                state.info.trialAlert = true
            }
            let date = new Date()
            let oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
            let exp = new Date(state.info.daysLeft)
            state.info.days = Math.round(Math.abs((date.getTime() - exp.getTime())/(oneDay)));
        }
        state.info.profileImage = data.user.profileImage
        state.info.loggedIn = true
        state.info.email = data.user.email
        state.info.userHash = data.userHash
        state.info.id = data.user.id
        state.info.accounts = data.accounts
        localStorage.setItem('user', JSON.stringify(data))
        Vue.gtm.dataLayer = {
            isLoggedIn: true,
            isDevServer: false,
            userHash: data.userHash,
            userId: data.user.id
        }
    },
    onError(state, error) {
        state.error = error
        if (error.response && error.response.status === 401) {
            state.info = defaultStatus()
            state.user = null;
            localStorage.setItem('user', JSON.stringify(null))
            Vue.gtm.dataLayer = {
                isLoggedIn: false,
                isDevServer: false,
                userHash: null,
                userId: null
            }
        }
    }
}

export const account = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
